import getValidColor from './get-valid-color';

export function getBgColor({ backgroundColor, hexColor }) {
  const hasHexcolorDropdown = backgroundColor === 'HEXCOLOR';
  const hasBgHexcolor = hexColor !== '';
  const color =
    hasHexcolorDropdown && hasBgHexcolor
      ? hexColor
      : getValidColor(backgroundColor);
  return color;
}
